import React from 'react';
import { Hero } from './Hero';
import { Story } from './Story';
import { Quotes } from './Quotes';
import { BookDetails } from './BookDetails';
import { SpecialOffer } from './SpecialOffer';
import { Footer } from './Footer';
export const BookPromo = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-30">
      <Hero data-id="element-31" />
      <Story data-id="element-32" />
      <Quotes data-id="element-33" />
      <BookDetails data-id="element-34" />
      <SpecialOffer data-id="element-35" />
      <Footer data-id="element-36" />
    </div>;
};